import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input
} from "@angular/core";

import { HelmChartMetaData, HelmChartSecurity } from "./../../service/interface";
import { downloadFile } from './../../utils';
import { HelmChartService } from "../../service/index";
import { ErrorHandler } from "./../../error-handler/error-handler";

@Component({
  selector: "hbr-chart-detail-summary",
  template: `<div class="row">
    <div class="col-md-12">
        <p>{{summary.description}}</p>
    </div>
</div>
<div class="row content-wrapper">
    <div class="col-md-8 md-container">
        <div *ngIf="readme" class="md-div" [innerHTML]="readme | markdown"></div>
        <div *ngIf="!readme">{{'HELM_CHART.NO_README' | translate}}</div>
    </div>
    <div class="col-md-4 summary-container">
        <div class="col-md-12 content-group">
            <div>
                <label>{{'HELM_CHART.OVERVIEW' | translate }}</label>
            </div>
            <table class="table">
                <tbody>
                    <tr>
                        <td class="left">{{'HELM_CHART.HOME' | translate }}</td>
                        <td class="left text-wrapper">
                            <a href="{{summary.home}}">{{summary.home}}</a>
                        </td>
                    </tr>
                    <tr *ngFor="let src of summary.sources; let i = index">
                        <td class="left" *ngIf="i === 0">{{'HELM_CHART.SRC_REPO' | translate }}</td>
                        <td class="left" *ngIf="i !== 0"></td>
                        <td class="left text-wrapper">
                            <a href="{{src}}">{{src}}</a>
                        </td>
                    </tr>
                    <tr>
                        <td class="left">{{'HELM_CHART.CREATED' | translate }}</td>
                        <td class="left">{{summary.created | date}}</td>
                    </tr>
                    <tr *ngFor="let maintainer of summary.maintainers; let i = index">
                        <td class="left" *ngIf="i === 0">{{'HELM_CHART.MAINTAINERS' | translate }}</td>
                        <td class="left" *ngIf="i !== 0"></td>
                        <td class="left">
                            <a href="mailto:{{maintainer.email}}">{{maintainer.name}}</a>
                        </td>
                    </tr>
                    <tr>
                        <td class="left">{{'HELM_CHART.APP_VERSION' | translate }}</td>
                        <td class="left">{{ summary.appVersion }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="col-md-12 content-group">
            <div>
                <label>{{'HELM_CHART.COMMAND' | translate }}</label>
            </div>
            <table class="table">
                <tbody>
                    <tr>
                        <td class="left cmd-title">{{'HELM_CHART.ADD_REPO' | translate }}</td>
                        <td class="left cmd-content">
                            <input class="cmd-content" type="text"
                            [(ngModel)]="addCMD" #addCMDInput readonly/>
                        </td>
                        <td class="left">
                            <span>
                                <clr-icon shape="copy" size="24"
                                [class.is-success]="isCopied('add')"
                                [ngxClipboard]="addCMDInput"
                                (cbOnSuccess)="onCopySuccess($event, 'add')"
                                ></clr-icon>
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td class="left cmd-title">{{'HELM_CHART.INSTALL_CHART' | translate }}</td>
                        <td class="left">
                            <input class="cmd-content" type="text"
                            [(ngModel)]="installCMD" #installCMDInput readonly/>
                        </td>
                        <td class="left">
                            <span>
                                <clr-icon shape="copy" size="24"
                                [class.is-success]="isCopied('install')"
                                [ngxClipboard]="installCMDInput"
                                (cbOnSuccess)="onCopySuccess($event, 'install')"
                                ></clr-icon>
                            </span>
                        </td>
                    </tr>
                    <tr *ngIf="prov_ready">
                        <td class="left cmd-title">{{'HELM_CHART.VERIFY_CHART' | translate }}</td>
                        <td class="left">
                            <input class="cmd-content" type="text"
                            [(ngModel)]="verifyCMD" #verifyCMDInput readonly/>
                        </td>
                        <td class="left">
                            <span>
                                <clr-icon shape="copy" size="24"
                                [class.is-success]="isCopied('verify')"
                                [ngxClipboard]="verifyCMDInput"
                                (cbOnSuccess)="onCopySuccess($event, 'verify')"
                                ></clr-icon>
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="col-md-12 content-group">
            <div>
                <label>{{'HELM_CHART.SECURITY' | translate }}</label>
            </div>
            <table class="table">
                <tbody>
                    <tr>
                        <td class="left">{{'HELM_CHART.PROV_FILE' | translate }}</td>
                        <div *ngIf="prov_ready;then signedContent else unsignedContent"></div>
                        <ng-template #signedContent>
                            <td class="left">
                                <span class="content-icon">
                                    <clr-icon shape="shield-check" class="is-success"></clr-icon>
                                </span>&nbsp;<a href="javascript:void(0)" (click)="downloadChart()">{{'HELM_CHART.READY' | translate }}</a>
                            </td>
                        </ng-template>
                        <ng-template #unsignedContent>
                            <td class="left">
                                <span class="content-icon">
                                    <clr-icon shape="shield-x" class="is-error"></clr-icon>
                                </span>&nbsp;{{'HELM_CHART.NOT_READY' | translate }}</td>
                        </ng-template>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

</div>`,
  styles: [`.content-wrapper{margin-top:20px;padding:0 0 0 15px}.content-wrapper .md-container{border:1px solid #ddd}.content-wrapper .summary-container{padding:0}.content-wrapper .summary-container table{background-color:#f2f2f2;margin-top:.5rem}.content-wrapper .summary-container .content-group{margin-bottom:30px}.content-wrapper .summary-container .content-icon{margin-right:6px}.content-wrapper .summary-container .text-wrapper{word-break:break-all}.content-wrapper .cmd-title{white-space:nowrap;vertical-align:middle}.content-wrapper .cmd-content{width:100%}`],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChartDetailSummaryComponent implements OnInit {
  @Input() summary: HelmChartMetaData;
  @Input() security: HelmChartSecurity;
  @Input() repoURL: string;
  @Input() projectName: string;
  @Input() chartName: string;
  @Input() chartVersion: string;
  @Input() readme: string;

  copiedCMD = '';
  addCMD: string;
  installCMD: string;
  verifyCMD: string;

  constructor(
    private errorHandler: ErrorHandler,
    private helmChartService: HelmChartService
  ) {}

  ngOnInit(): void {
    this.addCMD = `helm repo add --ca-file <ca file> --cert-file <cert file> --key-file <key file> --username <username> --password <password> <repo name> ${this.repoURL}/chartrepo/${this.projectName}`;
    this.installCMD = `helm install --ca-file <ca file> --cert-file <cert file> --key-file <key file> --username=<username> --password=<password> --version ${this.chartVersion} <repo name>/${this.chartName}`;
    this.verifyCMD = `helm verify --keyring <key path> ${this.chartName}-${this.chartVersion}.tgz`;
  }

  isCopied(cmd: string) {
    return this.copiedCMD === cmd;
  }

  onCopySuccess(e: Event, cmd: string) {
    this.copiedCMD = cmd;
  }

  public get prov_ready() {
    return this.security && this.security.signature && this.security.signature.signed;
  }

  downloadChart() {
    if (!this.summary ||
      !this.summary.urls ||
      this.summary.urls.length < 1) {
      return;
    }
    let filename = `${this.summary.urls[0]}.prov`;

    this.helmChartService.downloadChart(this.projectName, filename).subscribe(
      res => {
        downloadFile(res);
      },
      error => {
        this.errorHandler.error(error);
      },
    );
  }

}
